<template>
  <div class="page-content">
    <!-- 头部区域 -->
    <header class=" bg-gradient-primary header-gradient text-white py-20 px-6 md:px-12">
      <div class="max-w-5xl mx-auto text-center">
        <h1 class="text-4xl md:text-5xl font-bold mb-6">视频中心</h1>
        <div class="text-lg text-white/90 max-w-3xl mx-auto">
          <p>促进会展行业深度交流与合作，搭建信息共享与资源对接桥梁，汇聚行业精英、分享前沿动态、分析市场趋势，共同推动会展行业创新发展与转型升级。</p>
        </div>
      </div>
    </header>

    <!-- 新增的大按钮区域 -->
<!--    <section class="container mx-auto py-8">
      <div class="category-buttons grid grid-cols-1 md:grid-cols-3 gap-6">
        <div class="category-button selected">
          <i class="fas fa-video"></i>
          <h3>展会直播</h3>
          <p>实时观看各类展会现场直播，不错过任何精彩内容</p>
        </div>
        <div class="category-button">
          <i class="fas fa-user-tie"></i>
          <h3>大咖分享</h3>
          <p>行业专家深度解析，把握最新趋势和前沿动态</p>
        </div>
        <div class="category-button">
          <i class="fas fa-graduation-cap"></i>
          <h3>线上课程</h3>
          <p>系统化学习会展知识，提升专业技能水平</p>
        </div>
      </div>
    </section>-->

    <main class="container mx-auto py-8 margin-top-div">
      <!-- 推荐直播区域 -->
      <section class="mb-12">
        <div class="section-header">
          <h2 class="text-2xl font-bold">推荐直播</h2>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <!-- 推荐直播卡片1 -->
          <div class="live-card">
            <div class="image-container">
              <img src="../assets/images/video/img1.png" alt="全球数字经济大会" class="w-full h-48 object-cover">
              <div class="live-badge">
                <span>直播中</span>
              </div>
            </div>
            <div class="p-4">
              <div class="title-container">
                <h3 class="text-lg font-semibold event-title">全球数字经济大会</h3>
                <span class="tag tag-free">免费观看</span>
              </div>
              <div class="flex items-center text-gray-500 text-sm mb-3">
                <i class="far fa-calendar-alt mr-2"></i>
                <span>2026-06-15 09:00-17:00</span>
              </div>
              <div class="flex items-center text-gray-500 text-sm mb-3">
                <i class="fas fa-map-marker-alt mr-2"></i>
                <span>北京国家会议中心</span>
              </div>
              <div class="flex flex-wrap">
                <span class="tag tag-industry">数字经济</span>
                <span class="tag tag-industry">科技创新</span>
              </div>
            </div>
          </div>

          <!-- 推荐直播卡片2 -->
          <div class="live-card">
            <div class="image-container">
              <img src="../assets/images/video/img2.png" alt="中国智能制造产业博览会" class="w-full h-48 object-cover">
              <div class="live-badge">
                <span>直播中</span>
              </div>
            </div>
            <div class="p-4">
              <div class="title-container">
                <h3 class="text-lg font-semibold event-title">中国智能制造产业博览会</h3>
                <span class="tag tag-paid">会员专享</span>
              </div>
              <div class="flex items-center text-gray-500 text-sm mb-3">
                <i class="far fa-calendar-alt mr-2"></i>
                <span>2026-06-16 10:00-16:30</span>
              </div>
              <div class="flex items-center text-gray-500 text-sm mb-3">
                <i class="fas fa-map-marker-alt mr-2"></i>
                <span>上海新国际博览中心</span>
              </div>
              <div class="flex flex-wrap">
                <span class="tag tag-industry">智能制造</span>
                <span class="tag tag-industry">工业4.0</span>
              </div>
            </div>
          </div>

          <!-- 推荐直播卡片3 -->
          <div class="live-card">
            <div class="image-container">
              <img src="../assets/images/video/img3.jpg" alt="国际绿色能源与环保技术展览会" class="w-full h-48 object-cover">
              <div class="live-badge">
                <span>直播中</span>
              </div>
            </div>
            <div class="p-4">
              <div class="title-container">
                <h3 class="text-lg font-semibold event-title">国际绿色能源与环保技术展览会</h3>
                <span class="tag tag-free">免费观看</span>
              </div>
              <div class="flex items-center text-gray-500 text-sm mb-3">
                <i class="far fa-calendar-alt mr-2"></i>
                <span>2026-06-14 09:30-17:30</span>
              </div>
              <div class="flex items-center text-gray-500 text-sm mb-3">
                <i class="fas fa-map-marker-alt mr-2"></i>
                <span>广州琶洲国际会展中心</span>
              </div>
              <div class="flex flex-wrap">
                <span class="tag tag-industry">绿色能源</span>
                <span class="tag tag-industry">环保技术</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 即将开始的直播区域 -->
      <section class="mb-12">
        <div class="section-header">
          <h2 class="text-2xl font-bold">即将开始的直播</h2>
          <button class="view-more">
            查看更多 <i class="fas fa-chevron-right ml-1 text-xs"></i>
          </button>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <!-- 即将开始的直播卡片1 -->
          <div class="live-card">
            <div class="image-container">
              <img src="https://s.coze.cn/image/2YMXENaHv3w/" alt="中国国际医疗器械博览会" class="w-full h-48 object-cover">
              <div class="upcoming-indicator">
                <span>即将开始</span>
              </div>
            </div>
            <div class="p-4">
              <div class="title-container">
                <h3 class="text-lg font-semibold event-title">中国国际医疗器械博览会</h3>
                <span class="tag tag-paid">会员专享</span>
              </div>
              <div class="flex items-center text-gray-500 text-sm mb-3">
                <i class="far fa-calendar-alt mr-2"></i>
                <span>2026-06-18 09:00-17:00</span>
              </div>
              <div class="flex items-center text-gray-500 text-sm mb-3">
                <i class="fas fa-map-marker-alt mr-2"></i>
                <span>深圳国际会展中心</span>
              </div>
              <div class="flex flex-wrap">
                <span class="tag tag-industry">医疗器械</span>
                <span class="tag tag-industry">医疗健康</span>
              </div>
            </div>
          </div>

          <!-- 即将开始的直播卡片2 -->
          <div class="live-card">
            <div class="image-container">
              <img src="https://s.coze.cn/image/93DwCkuAN2g/" alt="亚洲教育科技峰会" class="w-full h-48 object-cover">
              <div class="upcoming-indicator">
                <span>即将开始</span>
              </div>
            </div>
            <div class="p-4">
              <div class="title-container">
                <h3 class="text-lg font-semibold event-title">亚洲教育科技峰会</h3>
                <span class="tag tag-free">免费观看</span>
              </div>
              <div class="flex items-center text-gray-500 text-sm mb-3">
                <i class="far fa-calendar-alt mr-2"></i>
                <span>2026-06-19 10:00-16:00</span>
              </div>
              <div class="flex items-center text-gray-500 text-sm mb-3">
                <i class="fas fa-map-marker-alt mr-2"></i>
                <span>杭州国际博览中心</span>
              </div>
              <div class="flex flex-wrap">
                <span class="tag tag-industry">教育科技</span>
                <span class="tag tag-industry">在线教育</span>
              </div>
            </div>
          </div>

          <!-- 即将开始的直播卡片3 -->
          <div class="live-card">
            <div class="image-container">
              <img src="https://s.coze.cn/image/tMiIqNTYBAc/" alt="中国汽车产业发展论坛" class="w-full h-48 object-cover">
              <div class="upcoming-indicator">
                <span>即将开始</span>
              </div>
            </div>
            <div class="p-4">
              <div class="title-container">
                <h3 class="text-lg font-semibold event-title">中国汽车产业发展论坛</h3>
                <span class="tag tag-paid">会员专享</span>
              </div>
              <div class="flex items-center text-gray-500 text-sm mb-3">
                <i class="far fa-calendar-alt mr-2"></i>
                <span>2026-06-20 09:30-17:30</span>
              </div>
              <div class="flex items-center text-gray-500 text-sm mb-3">
                <i class="fas fa-map-marker-alt mr-2"></i>
                <span>成都国际会议中心</span>
              </div>
              <div class="flex flex-wrap">
                <span class="tag tag-industry">汽车产业</span>
                <span class="tag tag-industry">新能源</span>
              </div>
            </div>
          </div>

          <!-- 即将开始的直播卡片4 -->
          <div class="live-card">
            <div class="image-container">
              <img src="https://s.coze.cn/image/ZXyBAjOa4N8/" alt="智慧农业与乡村振兴峰会" class="w-full h-48 object-cover">
              <div class="upcoming-indicator">
                <span>即将开始</span>
              </div>
            </div>
            <div class="p-4">
              <div class="title-container">
                <h3 class="text-lg font-semibold event-title">智慧农业与乡村振兴峰会</h3>
                <span class="tag tag-free">免费观看</span>
              </div>
              <div class="flex items-center text-gray-500 text-sm mb-3">
                <i class="far fa-calendar-alt mr-2"></i>
                <span>2026-06-21 10:00-16:30</span>
              </div>
              <div class="flex items-center text-gray-500 text-sm mb-3">
                <i class="fas fa-map-marker-alt mr-2"></i>
                <span>南京国际博览中心</span>
              </div>
              <div class="flex flex-wrap">
                <span class="tag tag-industry">智慧农业</span>
                <span class="tag tag-industry">乡村振兴</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 往期直播回放区域 -->
      <section>
        <div class="section-header">
          <h2 class="text-2xl font-bold">往期直播回放</h2>
          <button class="view-more">
            查看更多 <i class="fas fa-chevron-right ml-1 text-xs"></i>
          </button>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <!-- 往期直播回放卡片1 -->
          <div class="live-card">
            <div class="image-container">
              <img src="https://s.coze.cn/image/FW3fnLDgfTA/" alt="人工智能与大数据应用大会" class="w-full h-48 object-cover">
              <div class="time-badge">02:15:33</div>
            </div>
            <div class="p-4">
              <div class="title-container">
                <h3 class="text-lg font-semibold event-title">人工智能与大数据应用大会</h3>
                <span class="tag tag-free">免费观看</span>
              </div>
              <div class="flex items-center text-gray-500 text-sm mb-3">
                <i class="far fa-calendar-alt mr-2"></i>
                <span>2026-06-10 09:00-17:00</span>
              </div>
              <div class="flex items-center text-gray-500 text-sm mb-3">
                <i class="fas fa-map-marker-alt mr-2"></i>
                <span>北京国际会议中心</span>
              </div>
              <div class="flex flex-wrap">
                <span class="tag tag-industry">人工智能</span>
                <span class="tag tag-industry">大数据</span>
              </div>
            </div>
          </div>

          <!-- 往期直播回放卡片2 -->
          <div class="live-card">
            <div class="image-container">
              <img src="https://s.coze.cn/image/BXv-1VGWA34/" alt="区块链技术与应用峰会" class="w-full h-48 object-cover">
              <div class="time-badge">01:58:22</div>
            </div>
            <div class="p-4">
              <div class="title-container">
                <h3 class="text-lg font-semibold event-title">区块链技术与应用峰会</h3>
                <span class="tag tag-paid">会员专享</span>
              </div>
              <div class="flex items-center text-gray-500 text-sm mb-3">
                <i class="far fa-calendar-alt mr-2"></i>
                <span>2026-06-08 10:00-16:30</span>
              </div>
              <div class="flex items-center text-gray-500 text-sm mb-3">
                <i class="fas fa-map-marker-alt mr-2"></i>
                <span>上海新国际博览中心</span>
              </div>
              <div class="flex flex-wrap">
                <span class="tag tag-industry">区块链</span>
                <span class="tag tag-industry">数字经济</span>
              </div>
            </div>
          </div>

          <!-- 往期直播回放卡片3 -->
          <div class="live-card">
            <div class="image-container">
              <img src="https://s.coze.cn/image/0XYmiix8Fh8/" alt="物联网技术与智慧城市论坛" class="w-full h-48 object-cover">
              <div class="time-badge">02:42:11</div>
            </div>
            <div class="p-4">
              <div class="title-container">
                <h3 class="text-lg font-semibold event-title">物联网技术与智慧城市论坛</h3>
                <span class="tag tag-free">免费观看</span>
              </div>
              <div class="flex items-center text-gray-500 text-sm mb-3">
                <i class="far fa-calendar-alt mr-2"></i>
                <span>2026-06-05 09:30-17:30</span>
              </div>
              <div class="flex items-center text-gray-500 text-sm mb-3">
                <i class="fas fa-map-marker-alt mr-2"></i>
                <span>广州琶洲国际会展中心</span>
              </div>
              <div class="flex flex-wrap">
                <span class="tag tag-industry">物联网</span>
                <span class="tag tag-industry">智慧城市</span>
              </div>
            </div>
          </div>

          <!-- 往期直播回放卡片4 -->
          <div class="live-card">
            <div class="image-container">
              <img src="https://s.coze.cn/image/K7oh1T2tjDQ/" alt="元宇宙与数字孪生技术大会" class="w-full h-48 object-cover">
              <div class="time-badge">02:30:45</div>
            </div>
            <div class="p-4">
              <div class="title-container">
                <h3 class="text-lg font-semibold event-title">元宇宙与数字孪生技术大会</h3>
                <span class="tag tag-paid">会员专享</span>
              </div>
              <div class="flex items-center text-gray-500 text-sm mb-3">
                <i class="far fa-calendar-alt mr-2"></i>
                <span>2026-06-01 10:00-16:00</span>
              </div>
              <div class="flex items-center text-gray-500 text-sm mb-3">
                <i class="fas fa-map-marker-alt mr-2"></i>
                <span>深圳国际会展中心</span>
              </div>
              <div class="flex flex-wrap">
                <span class="tag tag-industry">元宇宙</span>
                <span class="tag tag-industry">数字孪生</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>

  </div>
</template>
<script>
export default {
  name: "VideoCenter",
  mounted () {
    // 组件挂载后再操作自己 DOM
    const liveCards = this.$el.querySelectorAll('.live-card')
    liveCards.forEach(card => {
      card.addEventListener('click', function () {
        console.log('直播卡片点击')
      })
    })

    const categoryButtons = this.$el.querySelectorAll('.category-button')
    categoryButtons.forEach((button) => {
      button.addEventListener('click', function () {
        // 清除所有 selected
        categoryButtons.forEach(btn => btn.classList.remove('selected'))
        // 当前按钮加 selected
        this.classList.add('selected')

        console.log('分类按钮点击: ' + this.querySelector('h3').textContent)
      })
    })
  }
}
</script>

<style scoped>
.page-content{
  padding-top: 20px;
  padding-bottom: 20px;
}
body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  background-color: #f8fafc;
  color: #1e293b;
}
.margin-top-div{
  margin-top: 40px !important
}

.bg-gradient-primary {
  background: linear-gradient(135deg, #1e40af 0%, #3b82f6 100%);
  border-radius: 20px 20px 0px 0px;
  margin-bottom: 20px;
}

.container {
  max-width: 1920px;
  margin: 0 auto;
  padding: 0 2rem;
}

.nav-button {
  position: relative;
  transition: all 0.3s ease;
}

.nav-button.active {
  color: #3b82f6;
  font-weight: 600;
}

.nav-button.active::after {
  content: '';
  position: absolute;
  bottom: -4px;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #3b82f6;
  border-radius: 2px;
}

.live-card {
  transition: all 0.3s ease;
  border-radius: 0.75rem;
  overflow: hidden;
  background-color: white;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.live-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

.live-card.selected {
  border: 2px solid #3b82f6;
  background-color: #f0f9ff;
}

.live-badge {
  position: absolute;
  top: 0.75rem;
  left: 0.75rem;
  background-color: #ef4444;
  color: white;
  padding: 0.25rem 0.75rem;
  border-radius: 9999px;
  font-size: 0.75rem;
  font-weight: 600;
  display: flex;
  align-items: center;
}

.live-badge::before {
  content: '';
  width: 6px;
  height: 6px;
  background-color: white;
  border-radius: 50%;
  margin-right: 0.5rem;
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

.tag {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 9999px;
  font-size: 0.75rem;
  font-weight: 500;
  margin-right: 0.5rem;
  margin-bottom: 0.5rem;
  white-space: nowrap;
}

.tag-free {
  background-color: #dcfce7;
  color: #166534;
}

.tag-paid {
  background-color: #fef3c7;
  color: #92400e;
}

.tag-industry {
  background-color: #dbeafe;
  color: #1e40af;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.view-more {
  color: #3b82f6;
  font-weight: 500;
  display: flex;
  align-items: center;
  transition: all 0.2s ease;
}

.view-more:hover {
  color: #2563eb;
  transform: translateX(3px);
}

.image-container {
  position: relative;
  overflow: hidden;
  padding-top: 56.25%; /* 16:9 Aspect Ratio */
}

.image-container img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.live-card:hover .image-container img {
  transform: scale(1.05);
}

.time-badge {
  position: absolute;
  bottom: 0.75rem;
  right: 0.75rem;
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  font-size: 0.75rem;
}

.upcoming-indicator {
  position: absolute;
  top: 0.75rem;
  left: 0.75rem;
  background-color: #3b82f6;
  color: white;
  padding: 0.25rem 0.75rem;
  border-radius: 9999px;
  font-size: 0.75rem;
  font-weight: 600;
}

/* 新增的大按钮样式 */
.category-button {
  transition: all 0.3s ease;
  border-radius: 0.75rem;
  overflow: hidden;
  background-color: white;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
  text-align: center;
}

.category-button:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

.category-button.selected {
  border: 2px solid #3b82f6;
  background-color: #f0f9ff;
  color: #000;
}

.category-button i {
  font-size: 2.5rem;
  margin-bottom: 1rem;
  color: #3b82f6;
}

.category-button h3 {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.category-button p {
  color: #64748b;
  font-size: 0.875rem;
}

/* 响应式设计 */
@media (max-width: 1280px) {
  .container {
    padding: 0 1.5rem;
  }
}

@media (max-width: 768px) {
  .container {
    padding: 0 1rem;
  }

  .nav-buttons {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
  }

  .nav-buttons::-webkit-scrollbar {
    display: none;
  }

  .category-buttons {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
}

/* 新增的样式：确保标题不换行并截断 */
.event-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 80%;
  display: inline-block;
  vertical-align: middle;
}

/* 确保标签和标题在同一行 */
.title-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.5rem;
}
</style>
